import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { closeModal } from '../../actions/ModalActions';
import Modal from '../Modal';
import discountApi from './discountApi';
import { benefitWindow, percent } from '../../utils/discountFormat';

/**
 * Cancel a client discount from an effective date. Days already earned keep
 * their discount on unbilled invoices; a discount that never started is
 * marked cancelled outright.
 */
@connect(
    () => ({}),
    dispatch => bindActionCreators({ closeModal }, dispatch)
)
export default class CancelDiscountModal extends Component {
    constructor(props) {
        super(props);
        this.state = { reason: '', effectiveOn: moment().format('YYYY-MM-DD'), isSaving: false, error: null };
    }

    handleSubmit() {
        this.setState({ isSaving: true, error: null });
        discountApi.cancelClientDiscount(this.props.clientId, this.props.discount.client_discount_id, {
            reason: this.state.reason,
            effective_on: this.state.effectiveOn || null
        }).then(() => {
            this.props.closeModal();
            if (this.props.onDone) {
                this.props.onDone();
            }
        }).catch(error => this.setState({ isSaving: false, error: error.message + (error.reason ? ` (${error.reason})` : '') }));
    }

    render() {
        var d = this.props.discount;
        var canSubmit = this.state.reason.trim() !== '' && !this.state.isSaving;
        var actionButton = (
            <button className={`btn btn-danger ${canSubmit ? '' : 'disabled'}`} onClick={canSubmit ? this.handleSubmit.bind(this) : undefined}>
                {this.state.isSaving ? 'Cancelling...' : 'Cancel discount'}
            </button>
        );
        return (
            <Modal actionButton={actionButton} className="modal-danger" title="Cancel discount">
                {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
                <p>
                    <strong>{d.coupon ? d.coupon.invoice_name : d.coupon_id}</strong> — {percent(d.percent_off)}, {benefitWindow(d.starts_on, d.ends_on)}
                </p>
                <div className="form-group">
                    <label>Effective from <small className="text-muted">the discount stops the day before</small></label>
                    <input type="date" className="form-control" value={this.state.effectiveOn} onChange={e => this.setState({ effectiveOn: e.target.value })} />
                </div>
                <div className="form-group">
                    <label>Reason</label>
                    <input className="form-control" value={this.state.reason} maxLength={500} onChange={e => this.setState({ reason: e.target.value })} />
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/discounts/CancelDiscountModal.js